import { ACTION_TYPES } from '../reducers/checkout.reducer';

const resetPlacedOrders = () => (dispatch: Function) => {
  dispatch({
    type: ACTION_TYPES.RESET_PLACED_ORDERS,
  });
};

export default resetPlacedOrders;
